import axios from 'axios'
import md5 from '@/js/md5.min.js'
import CryptoJS from '@/js/tripledes.js'
import utils from '@/common/utils.js'
import {
	Toast,
	Dialog
} from 'vant'
import {dingRequest} from './dingHttp.js'
import router from '@/router/index'
axios.defaults.timeout = 10000

var noToken = ['login/quick-token']
var paramStr = ''
var at_token = ''
const codeMessage = {
	666667: '请先进行面部识别',
	666668: '请先完善个人信息',
	666669: '请先进行实名认证',
	666670: '请先进行实名认证',
	666671: '请先完善个人信息',
	666672: '请先进行实名认证',
}

// 全局请求锁（阻塞除指定请求外的所有请求）
let __globalRequestLocked = false
let __unlockWaiters = []

function __waitForUnlock() {
    return new Promise(resolve => {
        if (!__globalRequestLocked) {
            resolve()
        } else {
            __unlockWaiters.push(resolve)
        }
    })
}

export function enableGlobalRequestLock() {
    __globalRequestLocked = true
}

export function releaseGlobalRequestLock() {
    __globalRequestLocked = false
    const waiters = __unlockWaiters.slice(0)
    __unlockWaiters = []
    waiters.forEach(fn => {
        try { fn() } catch (e) { console.warn(e) }
    })
}

// partner_auth_code 启动期阻塞与引导（在拦截器安装之后再执行）
function __bootstrapPartnerAuthIfNeeded() {
    if (typeof window === 'undefined') return
    try {
        const url = new URL(window.location.href)
        const code = url.searchParams.get('partner_auth_code')
        if (!code) return
        const lastCode = sessionStorage.getItem('last_partner_auth_code')
        const existingToken = sessionStorage.getItem('access_token')
        window.__partnerAuthBootstrapping = true
        enableGlobalRequestLock()
        if (code && lastCode === code && existingToken) {
            url.searchParams.delete('partner_auth_code')
            history.replaceState(null, '', url.toString())
            window.__partnerAuthBootstrapping = false
            releaseGlobalRequestLock()
            return
        }
        post('partner/user-info', { partner_auth_code: code }, 'cytx', 'bypass')
            .then(res => {
                if (res && res.data && res.data.access_token) {
                    sessionStorage.setItem('access_token', res.data.access_token)
                    sessionStorage.setItem('activity_source', 'cytx')
                    sessionStorage.setItem('cytx_access_token', res.data.access_token)
                    sessionStorage.setItem('last_partner_auth_code', code)
                }
                url.searchParams.delete('partner_auth_code')
                history.replaceState(null, '', url.toString())
            })
            .catch(() => {})
            .finally(() => {
                window.__partnerAuthBootstrapping = false
                releaseGlobalRequestLock()
            })
    } catch (e) {}
}

axios.interceptors.request.use(
    async config => {
        // 若开启了全局锁且当前请求未标记跳过，则等待解锁
        if (__globalRequestLocked && !config.__skipGlobalLock) {
            await __waitForUnlock()
        }
        var param = config.data
        if(typeof config.data == 'string'){
            return config
        }
        if(config.headers['Content-Type']=="multipart/form-data"){
            return config
        }
        if(!config.data.isCheck){
            if(config.apiType!=='new_share'){
                param = Encryption(config.data, config.url, config.authToken)
                config.data = config.apiType === 'share' ? {
                    share_data: param,
                    phone_type: 'ChuangYeTianXia/',
                    // version: process.env.VUE_APP_VERSION
                } : {
                    data: param,
                    phone_type: 'ChuangYeTianXia/',
                    // version: process.env.VUE_APP_VERSION
                }
            }
        }else{
            config.data = {
                sabi: param,
                phone_type: 'ChuangYeTianXia/',
                // version: process.env.VUE_APP_VERSION
            }
        }
		
		
		switch (config.apiType) {
			case 'cytx':
				config.baseURL = process.env.VUE_APP_NEW_API
				break;
			case 'live':
				config.baseURL = process.env.VUE_APP_LIVE_API
				break;
			case 'share':
				config.baseURL = process.env.VUE_APP_SHARE_API
				break
			case 'vlog':
				config.baseURL = process.env.VUE_APP_VLOG_API
				break
			case 'circle':
				config.baseURL = process.env.VUE_APP_CIRCLE_API
				break
			case 'voucher':
				config.baseURL = process.env.VUE_APP_BASE_VOUCHER_API
				break
			case 'new_share':
			    config.baseURL = process.env.VUE_APP_NEW_SHARE_API
				break
			case 'study':
			    config.baseURL = process.env.VUE_APP_STUDY_API
				break
			case 'zq_shop':
				config.baseURL = process.env.VUE_APP_ZQ_SHOP_API
				break
			default:
				break;
		}
		// config.baseURL='http://192.168.11.27:9507/';
		// config.baseURL='https://www.fastmock.site/mock/a4cc37dd978b5b99155feb7bf07fd0b8/txgx'
		// console.log('11111111', process.env.VUE_APP_VERSION)
		return config
	},
	error => {
		console.log(error)
	}
)

axios.interceptors.response.use(
	response => {
		const CODE = Number(response.data.code)
		if(response.data.errcode == 0){
			return
		}
		const STATUS = Number(response.status)
		if (STATUS === 200 && (CODE === 200 || CODE === 201 || CODE === 90024)) {
			return Promise.resolve(response)
		} else {
			// dingRequest(paramStr)
			switch (CODE) {
				case 0:break
				case 301:
					Toast('无效的Token')
					break
				case 619:
					Toast(response.data.message)
					break
				case 514:
					utils.needAuthentication()
					break
				case 803:
					Toast('当前网络问题，请稍后再试')
					dingRequest(paramStr)
					break
				case 214:
					break
				case 111035:
					router.push('/signingPromotional')
					break;
				case 666666:
					let app_version = utils.getAppData().app_version || '1.0.000'
					const isOld = utils.compareVersions(app_version, '3.5.410'); // -1小于  1大于  0等于  
					if (isOld == -1) { // 老版本
						Dialog.confirm({
							title: '提示',
							message: response.data.message,
							confirmButtonText: '实名认证',
							confirmButtonColor: '#ee4b62'
						}).then((r) => {
							if (r === 'confirm') {
								utils.toAuthentication()
							}
						}).catch(() => {});
					} else {
						Dialog.confirm({
							title: '提示',
							message: '请先进行实名认证',
							confirmButtonText: '去认证',
							confirmButtonColor: '#ee4b62'
						}).then((r) => {
							if (r === 'confirm') {
								utils.needCertification({code: CODE})
							}
						}).catch(() => {});
					}
					break
				case 666667:
					case 666668:
					case 666669:
					case 666670:
					case 666671:
					case 666672:
						let confirmText = '去认证'
						if (CODE == '666668' || CODE == '666671') {
							confirmText = '去完善'
						} else if (CODE == '666667') {
							confirmText = '去识别'
						}
						Dialog.confirm({
							title: '提示',
							message: codeMessage[CODE],
							confirmButtonText: confirmText,
							confirmButtonColor: '#ee4b62'
						}).then((r) => {
							if (r === 'confirm') {
								utils.needCertification({code: CODE})
							}
						}).catch(() => {});
						break
				default:
					if (CODE === 10014 || CODE === 10015) {
					} else {
						// Dialog.confirm({
						// 	title: '提示',
						// 	message: paramStr + JSON.stringify(response.data) ,
						// 	confirmButtonText: '关闭',
						// 	confirmButtonColor: '#ee4b62'
						// }).then(() => {
						// }).catch(() => {});
						// let appData = utils.getAppData();
						// Toast(response.data.message+';' + at_token + ';' + JSON.stringify(appData))
						if (response.data.message) Toast(response.data.message + '!')
					}
					break
			}
			return Promise.reject(response.data)
		}
	},
	error => {
		if (error.message === 'Network Error') {
			Toast('当前网络不可用')
		}
	}
)
// 在拦截器装配完毕后，执行 partner_auth_code 引导
__bootstrapPartnerAuthIfNeeded()
function getRequestKey(config) {
    const {
        url,
        params
    } = config
    return [url, JSON.stringify(params)].join('&')
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Boolean} isNewApi [当前请求为商城api还是new api，默认商城api]
 */
export function post(url, params = {}, type = 'cytx',isLock="unLock", authToken = '') {
    const Params = params
    // let urlStr = getRequestKey({url,params})
    // if(urlStr === localStorage.getItem('lockInfo')){
    // 	return
    // }
    return new Promise((resolve, reject) => {
        axios.post(url, Params, {
                apiType: type,
                authToken: authToken,
                // 当 isLock === 'bypass' 时，跳过全局请求锁
                __skipGlobalLock: isLock === 'bypass'
            })
            .then(res => {
                // localStorage.removeItem('lockInfo')
                resolve(res.data)
            })
            .catch(err => {
                // localStorage.removeItem('lockInfo')
                reject(err)
            })
            // if(isLock == 'lock'){
            // 	localStorage.setItem('lockInfo',urlStr)
            // }
    })
    
}

export function OSSUpload(url, param, File) {
	const formData = doData(param, File)
	return new Promise((resolve, reject) => {
		axios({
				url: url,
				method: 'post',
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(res => {
				resolve(res)
			})
			.catch(err => {
				reject(err)
			})
	})

	// return new Promise((resolve,reject) => {
	// 	axios.post(url,form)
	// })
}

function doData(Param, File) {
	const request = new FormData()
	const userId = localStorage.getItem('userId') || new Date().getTime()
	const key  = `${Param.dir}${userId}/${File.file.name}`
	request.append('key', key)
	// policy规定了请求的表单域的合法性
	request.append('policy', Param.policy)
	request.append('host', Param.host)
	// Bucket 拥有者的Access Key Id
	request.append('OSSAccessKeyId', Param.accessid)
	// 让服务端返回200,不然，默认会返回204
	request.append('success_action_status', '200')
	// 根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
	request.append('Callback', Param.callback)
	request.append('Signature', Param.signature)
	// request.append('rand', random);
	// request.append('access_token', token);
	// request.append('signature', md5(token + postfix + Config.key + random));
	// 需要上传的文件filer
	request.append('file', File.file)
	return request
}

// 获取验签
function EncryptionNew(param, url, token, random, version,app_version) {
	param.rand = random
	param.version = version
	param.access_token = token
	param.app_version = app_version || '1.0.000'
	var keys = Object.keys(param).sort();
	var newObj = {}
	for (var i = 0; i < keys.length; i++) {
		var index = keys[i];
		if(url=='corp-license/corp-license' && keys[i]=='account_name'){
			
		}else{
			newObj[index] = param[index];
		}
		
	}
	let strArray = []
	for (let item in newObj) {
		const ketV = item + '=' + encodeURIComponent(newObj[item])
		strArray.push(ketV)
	}
	strArray.push('key=' + process.env.VUE_APP_SignKey)
	strArray.push('method=' + url)
	let str = strArray.join('&')
	// console.log(str,'str')
	const SIGNATURE = md5(str);
	// paramStr = '加密串：' + SIGNATURE + ',未加密参数：' + str + '用户ip地址：' + returnCitySN["cip"] + '用户设备信息：' + navigator.userAgent
	
	paramStr = str.replace('key='+process.env.VUE_APP_SignKey,'')
	
	return SIGNATURE
}

// 参数加密
function Encryption(param, url, authToken = '') {
	try {

		let TOKEN = authToken
		const version = '3.6.710'
		if (noToken.some((current) => {
				return current !== url
			})) {

				if (!TOKEN && sessionStorage.getItem('access_token')) {
				    TOKEN = sessionStorage.getItem('access_token')
				} else if (!TOKEN) {
				    try {
				        const {access_token} = utils.getAppData()
				        TOKEN = access_token
				    } catch (error) {
				        console.log(error, 'error')
				    }
				}
				
			// if (utils.getUrlParam('access_token')) {
			// 	TOKEN = utils.getUrlParam('access_token')
			// } else if (sessionStorage.getItem('access_token')) {
			// 	TOKEN = sessionStorage.getItem('access_token')
			// } else {
			// 	try {
			// 		let appData = utils.getAppData(); //获取创业天下app传递信息
			// 		TOKEN = appData.access_token
			// 	} catch (err) {
			// 		console.log('token 丢失')
			// 	}
			// }
		}
		at_token = TOKEN

		const RANDOM = Math.round(new Date() / 1000);
		let app_version = utils.getAppData().app_version || '1.0.000'
		// const SIGNATURE = md5(TOKEN + url + process.env.VUE_APP_MD5K + RANDOM);

		const SIGNATURE = EncryptionNew(param, url, TOKEN, RANDOM, version,app_version);
		let argument = {
			...param,
			...{
				rand: RANDOM,
				access_token: TOKEN,
				signature: SIGNATURE,
				version,
				app_version: app_version || '1.0.000'
			}
		};
		let Str = '';
		Object.keys(argument).forEach((item) => {
			if (typeof argument[item] === 'object') {
				Str += item + '{[)`|}]' + JSON.stringify(argument[item]) + '[)`|})';
			} else {
				Str += item + '{[)`|}]' + argument[item] + '[)`|})';
			}
		})
		let keyHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_EncryptionKey);
		let encrypted = CryptoJS.DES.encrypt(Str, keyHex, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		});
		var EncryptionString = encrypted.toString();
		return EncryptionString
	} catch (e) {
		console.log(e);
		Toast('数据加密失败')
	}
}
